/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Base environment settings. This base environment config can be overriden in environment-specific configs.
 */

const urlParams = new URLSearchParams(window.location.search);
export const envParam = urlParams.get('env');

const base = {
  AI_ADMIN_API_BASE_URL: '/api/v1',
  AI_ADMIN_API_BASE_URL_V2: '/api/v2.0',
  AI_ADMIN_API_BASE_URL_V3: '/api/v3.0',
  AI_ADMIN_API_BASE_URL_V3_STACKB: '/api/v3.0',
  AI_ADMIN_API_TIMEOUT: 60000,
  PRODUCT: 'SAeT',
  BROWSER_REQUIREMENTS_URL:
    'https://www.pearson.com/us/higher-education/products-services-teaching/' +
    'course-content/textbooks-and-etexts/pearson-etext/system-requirements.html',
  BROWSER_CHECK: false,
  CLIENT_ID: '29s6iaLv3PblrAbzCP9kHlFY5ntGeNN7',
  INT_USER_PROFILE_URL: 'https://graph.microsoft.com/v1.0/me',
  INT_TIMEOUT: 60000,
  INT_AZURE_CLIENT_ID: '',
  AZURE_TENANT_ID: '209a71f6-c9bb-48f1-a23d-a26d275b75e2',
  AZURE_REDIRECT_URI: `${window.location.origin}/`,
  GTM_CONTAINER_ID: '',
  GTM_AUTH: '',
  GTM_PREVIEW: '',
  DELAYED_GTM: true,
  PSEUDO_LOCALE_CODE: 'pt',
  CORRELATION_ID_PREFIX: 'AIADMIN',
  NEWRELIC_CONFIG_NAME: '/newrelic/newrelic.js',
  NEWRELIC_ENABLED: false,
  NEWRELIC_CONFIG: {
    accountId: '',
    agentId: '',
    applicationId: '',
    licenseKey: '',
    trustKey: ''
  },
  TENANT_ID: {
    CHANNELS: 'a7167a3e-2538-4069-8f63-ef761f75b332',
    AI_STUDY_TOOLS: '32e81240-7457-11ed-89c4-a117ea7cad6a',
    PVS: '886a344d-54c0-4f87-82ae-3fab16af7e9e',
    SERVICENOW: 'bfff63e6-3f6b-4aa9-acd8-fab7a71ee8ed'
  },
  BERLIN_API_URI: 'https://berlin-api-pplus.etext-dev.pearsondev.tech',
  BERLIN_API_URI_STACKB: 'https://berlin-api-pplus.etext-dev.pearsondev.tech:8443',
  MIXPANEL_TOKEN: ''
};

export default base;
